import getDeleteCookieString from './getDeleteCookieString';

export default function deleteCookie(params: { domain?: string; name: string }): void {
  const toDelete = getDeleteCookieString(params);

  if (toDelete) {
    // deepcode ignore WebCookieSecureDisabledByDefault: Secure is appended dynamically in getDeleteCookieString function
    document.cookie = toDelete;
  }
}
